"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProofOfIdentityTask = void 0;
const tslib_1 = require("tslib");
const designed_1 = require("designed");
const class_validator_1 = require("class-validator");
const BaseTask_1 = require("../Task/BaseTask");
const ProofOfIdentitySubmission_1 = require("./ProofOfIdentitySubmission");
class ProofOfIdentityTask extends BaseTask_1.BaseTask {
}
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInstance)(ProofOfIdentitySubmission_1.ProofOfIdentitySubmission),
    (0, tslib_1.__metadata)("design:type", ProofOfIdentitySubmission_1.ProofOfIdentitySubmission)
], ProofOfIdentityTask.prototype, "proofOfIdentitySubmission", void 0);
exports.ProofOfIdentityTask = ProofOfIdentityTask;
